// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import * as Sentry from '@sentry/react';

import { SENTRY_DSN } from '../constants';

function initializeSentry() {
  try {
    Sentry.init({
      attachStacktrace: true,
      debug: process.env.NODE_ENV !== 'production',
      // Disable the TS render preview environments from firing Sentry errors
      denyUrls: ['https://trustshare-preview-pr'],
      dsn: SENTRY_DSN,
      enabled: process.env.NODE_ENV === 'production',
      environment: process.env.NODE_ENV,
      replaysSessionSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1,
      replaysOnErrorSampleRate: 1,
      integrations: [
        Sentry.browserTracingIntegration({ tracingOrigins: ['*'] }),
        Sentry.replayIntegration({
          /**
           * This is intentionally set to false so we can accurately see
           * where in the user journey the application threw an error
           */
          maskAllText: false,
          // https://github.com/getsentry/sentry-javascript/issues/6739
          useCompression: false,
        }),
      ],
      release: process.env.REACT_APP_RELEASE_BRANCH_NAME,
      tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.5 : 1,
      ignoreErrors: ['Non-Error promise rejection captured'],
    });
  } catch (e) {
    // Sentry has not loaded successfully.
  }
}

export default initializeSentry;
